import React, { useState, useEffect } from "react";
import axios from "axios";
import jwt from "jwt-decode";
//MUI
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
//My Components
import FactorGenerator from "../../components/FactorGenerator/FactorGenerator";
import WideLayout from "../../layouts/WideLayout";

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    cursor: {
        cursor: "pointer",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
}));

const AdminFactor = ({ history, match }) => {
    const classes = useStyles();
    const [factorList, setFactorList] = useState({});
    const [error, setError] = useState(false);

    const [factorLoading, setFactorLoading] = React.useState(true);
    const [factorData, setFactorData] = React.useState({});
    let id = match.params.id;
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            history.push("/");
        } else if (jwt(localStorage.getItem("token")).Roles !== "admin") {
            history.push("/");
        } else {
            getFactorDetail();
        }
    }, []);
    const getFactorDetail = async () => {
        setFactorLoading(true);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/invoices/show?invoiceId=${id}`,
                config
            );
            if (data.status === "ok") {
                setFactorData(data.data);
                setFactorLoading(false);
            } else {
                setFactorLoading(false);
                setError(true)
            }
        } catch (e) {
            console.log(e);
            setFactorLoading(false);
            setError(true)

        }
    };

    return (
        <WideLayout showBreadcrumbs={false}>
            <Grid container justify="center">
                <Grid item xs={11}>
                    {factorLoading && (
                        <Box
                            height="70vh"
                            display="flex"
                            justifyContent="center"
                            alignContent="center"
                            alignItems="center"
                        >
                            <CircularProgress size={44} />
                        </Box>
                    )}
                    {!factorLoading && (
                        <FactorGenerator confirm={true} factor={factorData} showPayment={true} print={true} />
                    )}
                </Grid>
            </Grid>
            {!factorLoading && !error && (<Box p={4} width="100%" textAlign="center">
                <Button onClick={() => history.push('/profile/manage-invoices')} variant="outlined" color="secondary">
                    بازگشت
        </Button>
            </Box>)}
        </WideLayout>
    );
};

export default AdminFactor;
